<script setup>
import FilterComponent from '@/@core/components/custom/FilterComponent.vue'
import AnalyticsTicketTracker from '@/@core/components/feedback/AnalyticsTicketTracker.vue'
import CustomerCommunicationDrawer from '@/views/feedback/customer-communication/Drawer.vue'
import CustomerCommunicationLogDrawer from '@/views/feedback/customer-communication/LogDrawer.vue'
import FeedbackResponseDrawer from '@/views/feedback/feedback-panel/drawer/FeedbackResponseDrawer.vue'
import TicketTable from '@/views/feedback/ticket-management/TicketTable.vue'
import TicketDrawer from '@/views/feedback/ticket-management/drawer/TicketDrawerV2.vue'
import { ref } from 'vue'
import { useRouter } from 'vue-router'

definePage({
  meta: {
    name: 'ticket-management',
    subject: 'feedback.menu',
    action: 'ticket_management',
  },  
})

const route = useRoute()

const selectedFilters = ref({})
const { data: filterOptions } = await useApi(createUrl('/feedbacks/ticket-filters'))

const ticketId = ref(null)
const isTicketDrawerVisible = ref(false)
const isFeedbackResponseDrawerVisible = ref(false)
const feedbackResponseDrawerData = ref()
const refTicketTable = ref()
const communicationDrawerData = ref()
const communicationDrawerType = ref('View')

const showTicket = data => {
  ticketId.value = data.id
  isTicketDrawerVisible.value = true
}

const showFeedbackResponse = (feedbackData, highlightedFeedbackResponse=null) => {
  feedbackResponseDrawerData.value = feedbackData
  feedbackResponseDrawerData.value.highlighted_feedback_response = highlightedFeedbackResponse
  isFeedbackResponseDrawerVisible.value = true
}

const isCommunicationDrawerVisible = ref(false)

const showCommunicationDrawer= (feedbackData, type, communicationFor='') => {
  communicationDrawerData.value = feedbackData
  communicationDrawerData.value.communicationFor = communicationFor
  isCommunicationDrawerVisible.value = true
}

const isCommunicationLogDrawerVisible = ref(false)

const showCommunicationLogDrawer = (feedbackData, type) => {
  communicationDrawerData.value = feedbackData
  isCommunicationLogDrawerVisible.value = true
}

const refTicketTracker =ref(null)

const refreshTicketData = async (closeDrawer = true) => {
  if (closeDrawer) isTicketDrawerVisible.value = false
  refTicketTable.value?.fetchTickets()
  refTicketTracker.value?.fetchStatusGraph()
}

const router = useRouter()

watch(
  () => route.query.ticket,
  async val => {
    if (val) {
      sessionStorage.setItem("ticketId", val)
      ticketId.value = val

      await router.replace({ path: route.path })
    } else {
      ticketId.value = sessionStorage.getItem("ticketId")
    }

    if (ticketId.value) {
      showTicket({ id: ticketId.value })
    }
  },
  { immediate: true },
)
</script>

<template>
  <section>
    <VRow class="match-height">
      <VCol
        cols="12"
        md="6"
        lg="6"
      >
        <FilterComponent
          v-model:filters="selectedFilters"
          :filters-options="filterOptions"
          :initial-visible-count="6"
          :style="{
            cardVariant: 'flat',
            cardClass: 'border',
          }"
        />
      </VCol>
      <VCol
        cols="12"
        md="6"
        lg="6"
      >
        <AnalyticsTicketTracker
          ref="refTicketTracker"
          :ticket-filters="selectedFilters"
          page="ticket-management"
          :style="{
            cardVariant: 'flat',
            cardClass: 'border',
          }"
        />
      </VCol>

      <VCol cols="12">
        <TicketTable
          ref="refTicketTable"
          :ticket-filters="selectedFilters"
          page="ticket-management"
          @show-ticket="showTicket"
          @show-feedback-response="showFeedbackResponse"
          @show-communication-drawer="showCommunicationDrawer"
          @show-communication-log-drawer="showCommunicationLogDrawer"
        />
      </VCol>
    </VRow>
  
    <FeedbackResponseDrawer
      v-model:isDrawerOpen="isFeedbackResponseDrawerVisible"
      :feedback-data="feedbackResponseDrawerData"
      :highlighted-feedback-question="feedbackResponseDrawerData?.highlighted_feedback_question"
      @show-communication-drawer="showCommunicationDrawer"
    />

    <CustomerCommunicationDrawer
      v-model:isDrawerOpen="isCommunicationDrawerVisible"
      :customer="communicationDrawerData?.customer"
      notification-action="ticket_customer_communication"
    />

    <CustomerCommunicationLogDrawer
      v-model:isDrawerOpen="isCommunicationLogDrawerVisible"
      :customer="communicationDrawerData?.customer"
      notification-action="ticket_customer_communication"
    />
    
    <TicketDrawer
      v-model:isDrawerOpen="isTicketDrawerVisible"
      :ticket-id="ticketId"
      @refresh-ticket-data="refreshTicketData"
      @show-feedback-response="showFeedbackResponse"
      @show-communication-drawer="showCommunicationDrawer"
    />
  </section>
</template>
